var _line, _line2, _path, _path2, _line3, _line4, _mask, _rect, _mask2, _rect2, _mask3, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 3,
    y2: 18,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 21,
    y2: 18,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H12H21",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H12H21",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 7,
    y2: 20,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 19,
    x2: 17,
    y2: 20,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_257_9164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 4,
    height: 4,
    rx: 1,
    strokeWidth: 3,
    mask: "url(#path-7-inside-1_257_9164)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_257_9164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 4,
    height: 4,
    rx: 1,
    strokeWidth: 3,
    mask: "url(#path-8-inside-2_257_9164)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-3_257_9164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 4,
    height: 4,
    rx: 1,
    strokeWidth: 3,
    mask: "url(#path-9-inside-3_257_9164)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.d9530f9cce1d4a9b964bef03cbba56fa.svg";
export { ForwardRef as ReactComponent };